import React, { useState, useEffect } from 'react';
import "./ConsentMapping.scss";
import Button from "react-bootstrap/esm/Button";
import { getAllMasterServices, saveFormTemplateSystemAdmin } from 'core/services/api';
import Toast from "components/Toast";


function ConsentMapping(formTemplate: any) {

  const [serviceIdName, setServiceIdName] = useState<any>(formTemplate?.formTemplate?.serviceIdName);
  const [selectedServices, setSelectedServices] = useState<string[]>([]);
  const [searchTerm, setSearchTerm] = useState<string>('');
  const [selectAll, setSelectAll] = useState<boolean>(false);
  const [displayToast, toggleDisplayToast] = useState<any>()

  useEffect(() => {
    getAllMasterServices().then((res: any) => {
      // Create a single object with IDs as keys and names as values
      const initialServiceIdName = res.reduce((acc: any, service: any) => {
        acc[service.id] = service.name;
        return acc;
      }, {});
      setServiceIdName(initialServiceIdName);
      const preSelectedArray = Object.keys(formTemplate?.formTemplate?.serviceIdName);
      setSelectedServices(preSelectedArray);

    }).catch((err: any) => {
      console.log(err);
    })

  }, [])

  const handleCheckboxChange = (serviceId: string) => {
    if (selectedServices.includes(serviceId)) {
      setSelectedServices(selectedServices.filter(id => id !== serviceId));
    } else {
      setSelectedServices([...selectedServices, serviceId]);
    }
  };
  const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearchTerm(event.target.value);
  };
  const handleSelectAll = () => {
    if (selectAll) {
      setSelectedServices([]);
    } else {
      setSelectedServices(Object.keys(serviceIdName));
    }
    setSelectAll(!selectAll);
  };


  const filteredServiceIdName: any = Object?.fromEntries(
    Object?.entries(serviceIdName)?.filter(([serviceId, serviceName]: any) =>
      serviceName.toLowerCase()?.includes(searchTerm.toLowerCase())
    )
  );

  const updateSelectedService = (() => {

    const formTemplateData = formTemplate?.formTemplate
    const data = [{
      id: formTemplateData?.id,
      type: formTemplateData?.type,
      subType: formTemplateData?.subType,
      centers: formTemplateData?.centers,
      servicesIds: selectedServices
    }];

    saveFormTemplateSystemAdmin(data)
      .then((res) => {
        toggleDisplayToast({ text: "Services Updated Successfully", type: "success" });
      })
      .catch((err) => {

        toggleDisplayToast({ text: "Cannot Update Service in Form Template", type: "error" });
      });
  })

  return (
    <div>
      <div className='consent-mapping-container'>
        <div className='serviceNameContainer'>
          <h2 className='heading'>Service Names</h2>
          <input
            type="text"
            className='search-box'
            placeholder="Search..."
            value={searchTerm}
            onChange={handleSearchChange}
          />
          <label style={{
            marginLeft: '30px'
          }}>
            <input
              type="checkbox"
              checked={selectAll}
              onChange={handleSelectAll}
            />
            <span className='subHeading'>Select All</span>
          </label>
          <ul>
            {Object.entries(filteredServiceIdName).map(([serviceId, serviceName]) => (
              <div key={serviceId}>
                <label>
                  <input
                    type="checkbox"
                    checked={selectedServices.includes(serviceId)}
                    onChange={() => handleCheckboxChange(serviceId)}
                  />
                  <span className='subHeading'> {serviceName} </span>
                </label>
              </div>
            ))}
          </ul>
        </div>
        <div className='selected-service-container'>
          <h3 className='heading'>Selected Services:</h3>
          <ul>
            {selectedServices.map(serviceId => (
              <li className='subHeading' key={serviceId}>{serviceIdName[serviceId]}</li>
            ))}
          </ul>
        </div>

      </div>
      <Button
        className='update-service'
        style={{
          height: '32px',
          marginTop: '20px',
          marginBottom: '20px',
          display: 'flex',
        }}
        onClick={() => updateSelectedService()}

      >
        Update
      </Button>
      {displayToast && (
        <Toast
          textMessage={displayToast?.text}
          type={displayToast?.type}
          onClose={() => {
            toggleDisplayToast(false)
            if (displayToast?.type === "success") {
              window.location.reload();
            }
          }}
          onCloseText="Close"
          onClickText={null}
        />
      )}
    </div>
  );
};


export default ConsentMapping;
